import { ProfitLevelIndicator as Component } from './components/ProfitLevelIndicator';
import Connector from './connector';

export const ProfitLevelIndicatorComponent = () => <Connector component={Component} />;
